import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from "./page-layout.component";
import { TranslateModule } from "@ngx-translate/core";
import { ValgDKSearchModule } from '../input/valgdk-search/valgdk-search.module';
import { SidenavigationModule } from '../sidenavigation/sidenavigation.module';
import { ResponsiveMenuModule } from '../responsive-menu/responsive-menu.module';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@valg-shared/pipes/pipes.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ValgDKSearchModule,
        SidenavigationModule,
        ResponsiveMenuModule,
        BreadcrumbsModule,
        MatIconModule,
        PipesModule
    ],
  declarations: [
    PageLayoutComponent
  ],
  exports: [
    PageLayoutComponent
  ]
})
export class PageLayoutModule {}
